var map = {
	"./01.jpg": 97,
	"./02.jpg": 98,
	"./03.jpg": 99,
	"./04.jpg": 100,
	"./05.jpg": 101,
	"./06.jpg": 102,
	"./07.jpg": 103,
	"./08.jpg": 104,
	"./09.jpg": 105,
	"./10.jpg": 106,
	"./11.jpg": 107,
	"./12.jpg": 108,
	"./13.jpg": 109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;